import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import luckysheet from "luckysheet";
import "luckysheet/dist/css/luckysheet.css";
import { listReponses } from "../../redux/actions/ListReponsesActions";
import { useParams } from "react-router-dom";

const UseDataSheet = () => {
  const { formId } = useParams();
  const [data, setData] = useState([]);
  const sheetRef = useRef();

  const dispatch = useDispatch();
  const listResponse = useSelector((state) => state.listReponses);
  const reponseAPI = listResponse?.responses?.data || [];

  useEffect(() => {
    if (formId) {
      dispatch(listReponses(formId));
    }
  }, [formId, dispatch]);

  useEffect(() => {
    if (reponseAPI.length === 0) return;

    const headers = [];
    const structuredData = [];

    reponseAPI.forEach((entry) => {
      const rowObj = {};
      entry.Answers.forEach(({ Field, value }) => {
        if (!headers.includes(Field.label)) headers.push(Field.label);
        rowObj[Field.label] = { value, type: Field.type };
      });
      structuredData.push(rowObj);
    });

    const celldata = [];

    // Headers (ligne 0)
    headers.forEach((header, c) => {
      celldata.push({
        r: 0,
        c,
        v: { v: header, t: "s" },
      });
    });

    // Contenu (lignes)
    structuredData.forEach((row, rIndex) => {
      headers.forEach((header, c) => {
        const cell = row[header];
        let cellValue = "";

        try {
          let formattedValue = cell?.value ?? "";

          // Cas fichier
          if (cell?.type === "file" && formattedValue) {
            const files = JSON.parse(formattedValue);
            if (Array.isArray(files)) {
              cellValue = files.map(f => f.name).join(", ");
            } else {
              cellValue = formattedValue;
            }

          // Cas tableau de valeurs
          } else if (typeof formattedValue === "string" && formattedValue.startsWith("[") && formattedValue.endsWith("]")) {
            const parsed = JSON.parse(formattedValue);
            if (Array.isArray(parsed)) {
              cellValue = parsed.join(", ");
            } else {
              cellValue = formattedValue;
            }

          // Cas date
          } else if (cell?.type === "date") {
            let formattedDate = formattedValue;
            if (formattedValue.includes("/")) {
              const [dd, mm, yyyy] = formattedValue.split("/").map(Number);
              formattedDate = `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
            }

            cellValue = {
              v: formattedDate,
              m: formattedDate,
              t: "s",
            };

          // Autres types (texte brut)
          } else {
            cellValue = formattedValue;
          }

        } catch {
          cellValue = {
            v: cell?.value ?? "",
            t: "s",
          };
        }

        celldata.push({
          r: rIndex + 1,
          c,
          v: cellValue,
        });
      });
    });

    const luckyData = [
      {
        name: "Feuille1",
        celldata,
        config: {},
        index: 0,
        row: structuredData.length + 20,
        column: headers.length + 5,
      },
    ];

    if (sheetRef.current) {
      const containerId = `datasheet_${formId || "default"}`;
      sheetRef.current.setAttribute("id", containerId);

      luckysheet.create({
        container: containerId,
        data: luckyData,
        showinfobar: false,
      });
    }

    setData({ headers, structuredData });
  }, [reponseAPI]);

  return { sheetRef, data };
};

export default UseDataSheet;
